export default "__VITE_ASSET__BCFvwdlM__$_?component__"